import { injectExternalScript } from '~/middlewares/injectExternalScript';

const siteKey =
  process.env.REACT_APP_RECAPTCHA_V3_SITEKEY ||
  '6LcCpYgUAAAAAJbjpAF_j22dSBzPVDoU6WdtsbBy';
const scriptNodeId = 'recaptchaInit';

const callbacks = [];

export function initialiseRecaptcha() {
  const onLoad = () => {
    window.grecaptcha.enterprise.ready(() => {
      while (callbacks.length > 0) {
        callbacks.shift()();
      }
    });
  };
  injectExternalScript({
    providerName: 'reCAPTCHA',
    id: scriptNodeId,
    attributeMap: {
      src: `https://www.google.com/recaptcha/enterprise.js?render=${siteKey}`,
    },
    onLoad,
  });
}

export function onRecaptchaLoaded(cb) {
  if (window.grecaptcha?.enterprise) {
    window.grecaptcha.enterprise.ready(() => {
      cb();
    });
  } else {
    const el = document.getElementById(scriptNodeId);
    if (el) {
      callbacks.push(cb);
    } else {
      cb(new Error('reCAPTCHA not initialised'));
    }
  }
}

export async function executeRecaptcha(action) {
  return new Promise((resolve, reject) => {
    onRecaptchaLoaded((err) => {
      if (err) {
        reject(err);
      } else {
        resolve(window.grecaptcha.enterprise.execute(siteKey, { action }));
      }
    });
  });
}

export default {
  initialiseRecaptcha,
  executeRecaptcha,
  onRecaptchaLoaded,
};
